import React from 'react';

const Footer: React.FC = () => {

  // var [urll, setUrll]: any = useState();
  // var [index, setIndex]: any = useState();

  // useEffect(() => {
  // })



  return (

    <div className="footer">

    </div>

  );

}


export default Footer;
